import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-horizontal-align-center",
  templateUrl: "./med-icon-horizontal-align-center.component.html",
})
export class MedIconHorizontalAlignCenterComponent extends SvgMixinComponent {}
